export class Key {
  constructor(private readonly id: number, private readonly description: string) {}

  getId() {
    return this.id;
  }

  getDescription() {
    return this.description;
  }
}
